!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((e = e || self)["@tinacms/alerts"] = {});
}(this, function (e) {
  "use strict";

  var t = (r.prototype.add = function (e, t, r) {
    var s = this;
    void 0 === r && (r = 3e3);
    var n = {
      level: e,
      message: t,
      timeout: r,
      id: t + "|" + Date.now()
    };

    function i() {
      clearTimeout(o), s.dismiss(n);
    }

    this.alerts.set(n.id, n), this.events.dispatch({
      type: "alerts:add",
      alert: n
    });
    var o = null;
    return o = setTimeout(i, n.timeout), i;
  }, r.prototype.dismiss = function (e) {
    this.alerts.delete(e.id), this.events.dispatch({
      type: "alerts:remove",
      alert: e
    });
  }, r.prototype.subscribe = function (e) {
    var t = this.events.subscribe("alerts", e);
    return function () {
      return t();
    };
  }, Object.defineProperty(r.prototype, "all", {
    get: function get() {
      return Array.from(this.alerts.values());
    },
    enumerable: !0,
    configurable: !0
  }), r.prototype.info = function (e, t) {
    return this.add("info", e, t);
  }, r.prototype.success = function (e, t) {
    return this.add("success", e, t);
  }, r.prototype.warn = function (e, t) {
    return this.add("warn", e, t);
  }, r.prototype.error = function (e, t) {
    return this.add("error", e, t);
  }, r);

  function r(e) {
    this.events = e, this.alerts = new Map();
  }

  e.Alerts = t, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});